import { createAsyncThunk, createSlice, } from '@reduxjs/toolkit'
import { AppState } from '@app/store/state/app.state';
import { findAllOrphanedUsers } from '@features/settings/services/ManagementService';
import { updateCompany } from '@features/settings/services/CompanyService';
import { TeamWithCount } from '@shared/models/team.models';
import { failureNotification, successNotification } from '@shared/store/notification.duck';
import { BasicUserInfo } from '@shared/models/user.models';
import { putUserInTeam } from '@shared/services/TeamService';
import { loadConfig } from "@shared/store/config.duck";

export interface ManagementState {
  teams: TeamWithCount[];
  orphanedUsers: BasicUserInfo[];
}

export const initialManagementState: ManagementState = {
  teams: [],
  orphanedUsers: [],
}

export const loadOrphanedUsers = createAsyncThunk(
  'management/loadOrphanedUsers',
  async () => await findAllOrphanedUsers()
);

export const updateUserTeam = createAsyncThunk('management/updateUserTeam',
  async (payload: { user: BasicUserInfo, teamId: string }, thunkAPI) => {
    try {
      await putUserInTeam(payload.user.userId, payload.teamId);
      await thunkAPI.dispatch(loadOrphanedUsers());
      await thunkAPI.dispatch(loadConfig());
      thunkAPI.dispatch(successNotification('User assigned to team'));
    } catch (err: any) {
      thunkAPI.dispatch(failureNotification('Request failed'));
    }
  }
);

export const updateCompanyName = createAsyncThunk(
  'management/updateCompany',
  async (companyName: any, thunkAPI) => {
    const appState = (thunkAPI.getState() as AppState);
    if (companyName === appState.auth.currentUser?.companyEntity.name) {
      return;
    }
    try {
      await updateCompany({...appState.auth.currentUser?.companyEntity, name: companyName});
      await thunkAPI.dispatch(loadConfig());
    } catch {
      await thunkAPI.dispatch(failureNotification('Failed to update company name'));
    }
  }
);


const slice = createSlice({
  name: 'management',
  initialState: initialManagementState,
  reducers: {
    reset: () => initialManagementState,
  },
  extraReducers: (builder) => {}
})

export default slice.reducer;


// Selectors
export const selectOrphanedUsers = (state: AppState) => state.management.orphanedUsers;
